export const styles = {
  container: {
    paddingTop: '32px',
  },
  zip: {
    '& input[type="number"]::-webkit-outer-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '& input[type="number"]::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    /* Para Firefox */
    '& input[type="number"]': {
      MozAppearance: 'textfield',
    },
  },
};
